<template>
    <div>
        <div v-if="successMessage" class="alert alert-success" style="color: rgb(5, 20, 48)">
            {{ successMessage }}
        </div>
        <b-card>
            <b-row>
                <div class="col-12 mt-16">
                    <b-form @submit.prevent="addUser" v-if="show">
                        <div style="
                background-color: rgb(97, 116, 152);
                height: 32px;
                border-radius: 4px;
              ">
                            <h4 style="
                  color: rgb(223, 227, 238);
                  margin-left: 5px;
                  font-weight: bold;
                ">
                                Vehicle Information
                            </h4>
                        </div>
                        <div class="row">
                            <!-- <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Company Name:" label-for="company_name">
                                    <b-form-input id="company_name" placeholder="Enter company name"
                                        v-model="company_name" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div> -->
                            <div class="col-md-4 col-12">
                                <b-form-group label="Category Name:" label-for="category">
                                    <b-form-input id="category" placeholder="Enter  vehicle category" v-model="category"
                                        disabled></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group label="Brand Name:" label-for="brand">
                                    <b-form-input id="brand" placeholder="Enter vehicle brand" v-model="brand"
                                        disabled></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group label="Brand Model:" label-for="model">
                                    <b-form-input id="model" placeholder="Enter vehicle model" v-model="model"
                                        disabled></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Color:" label-for="color">
                                    <b-form-input id="color" placeholder="Enter vehicle color" v-model="color" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="License Plate: " label-for="license_plate">
                                    <b-form-input id="license_plate" placeholder="Enter license plate"
                                        v-model="license_plate" disabled></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Engine Number: " label-for="engine_number">
                                    <b-form-input id="engine_number" placeholder="Enter engine number"
                                        v-model="engine_number" disabled></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Approve Status: " label-for="types">
                                    <b-form-input id="types" placeholder="Enter types" v-model="types"
                                        disabled></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Registration  Number: "
                                    label-for="registration_number">
                                    <b-form-input id="registration_number" placeholder="Enter registration number"
                                        v-model="registration_number" disabled></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Year: " label-for="year">
                                    <b-form-input id="year" placeholder="Enter vehicle year" v-model="year"
                                        disabled></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Identification Number: "
                                    label-for="vin">
                                    <b-form-input id="vin" placeholder="Enter vehicle identification number:"
                                        v-model="vin" disabled></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Unique Identification Code:" label-for="uic">
                                    <b-form-input id="uic" placeholder="Enter unique identification code" v-model="uic"
                                        disabled></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Description:" label-for="description">
                                    <textarea class="form-control" type="text" id="description" placeholder="Enter description" v-model="description"
                                        disabled>
                                    </textarea>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Features:" label-for="features">
                                    <b-form-input id="features" placeholder="Features" v-model="features" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Status: " label-for="status">
                                    <b-form-input id="status" placeholder="Enter vehicle status" v-model="status"
                                        disabled></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="SystemNo:" label-for="SystemNo">
                                    <b-form-input id="SystemNo" placeholder="Enter SystemNo"  v-model="SystemNo"
                                        disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Insurance Company Name:" label-for="insurance_company_name">
                                    <b-form-input id="insurance_company_name" placeholder="Enter Insurance Company Name" v-model="insurance_company_name"
                                        disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Insurance Policy Number:" label-for="insurance_policy_number">
                                    <b-form-input id="insurance_policy_number" placeholder="Enter Insurance Policy Number" v-model="insurance_policy_number"
                                        disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="Insurance Expiration Date:" label-for="insurance_expiration_date">
                                    <b-form-input id="insurance_expiration_date" type="date" v-model="insurance_expiration_date"
                                        disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-4 col-12">
                                <b-form-group id="input-group-2" label="WOSS System Installation Date:" label-for="install_date">
                                    <b-form-input id="install_date" placeholder="WOSS System Installation Date" type="datetime-local" v-model="install_date" disabled>
                                    </b-form-input>
                                </b-form-group>
                            </div>

                            <div v-if="lightboxVisible" class="lightbox" @click="closeLightbox">
                                <div class="lightbox-content">
                                    <img :src="selectedImage" alt="Vehicle Image" class="lightbox-image" />
                                </div>
                            </div>
                            <div class="col-md-6 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Images:" label-for="images">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <b-button v-if="image && image.length > 1" size="sm" :variant="imageReorderMode ? 'warning' : 'info'" @click="toggleImageReorder">
                                            {{ imageReorderMode ? 'Cancel' : 'Reorder Images' }}
                                        </b-button>
                                        <b-button v-if="imageReorderMode" size="sm" variant="success" @click="saveImageOrder" :disabled="savingImageOrder">
                                            <span v-if="!savingImageOrder">Save Order</span>
                                            <b-spinner v-else small></b-spinner>
                                        </b-button>
                                    </div>
                                    <draggable v-if="imageReorderMode" v-model="imageList" handle=".drag-handle" tag="div" class="d-flex flex-wrap">
                                        <div v-for="(img, index) in imageList" :key="index" class="reorder-image-item mr-2 mb-2 text-center">
                                            <span class="drag-handle" style="cursor: grab; font-size: 16px; display: block;">&#x2630;</span>
                                            <img :src="'https://wossdb.wossautoid.com/' + img" alt="Vehicle Image" width="100" height="100" class="border rounded" />
                                            <div class="small text-muted">{{ index + 1 }}</div>
                                        </div>
                                    </draggable>
                                    <div v-else-if="image && image.length" style="margin-left: 3px; margin-bottom: 15px">
                                        <img v-for="(img, index) in image" :key="index"
                                            :src="'https://wossdb.wossautoid.com/' + img" alt="Vehicle Image"
                                            width="100" height="100" style="margin-right: 10px; cursor: pointer;"
                                            @click="openLightbox(img)" />
                                    </div>
                                    <div v-else>
                                        <span>No image available</span>
                                    </div>
                                </b-form-group>
                            </div>

                            <div class="col-md-6 col-12">
                                <b-form-group id="input-group-2" label="Vehicle Documents:" label-for="documents">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <b-button v-if="documents && documents.length > 1" size="sm" :variant="docReorderMode ? 'warning' : 'info'" @click="toggleDocReorder">
                                            {{ docReorderMode ? 'Cancel' : 'Reorder Documents' }}
                                        </b-button>
                                        <b-button v-if="docReorderMode" size="sm" variant="success" @click="saveDocOrder" :disabled="savingDocOrder">
                                            <span v-if="!savingDocOrder">Save Order</span>
                                            <b-spinner v-else small></b-spinner>
                                        </b-button>
                                    </div>
                                    <draggable v-if="docReorderMode" v-model="docList" handle=".drag-handle" tag="div">
                                        <div v-for="(doc, index) in docList" :key="doc.id" class="reorder-row d-flex align-items-center p-2 mb-1 border rounded">
                                            <span class="drag-handle mr-3" style="cursor: grab; font-size: 20px;">&#x2630;</span>
                                            <span class="mr-2 font-weight-bold">{{ index + 1 }}.</span>
                                            <i class="fas fa-file-pdf mr-2"></i>
                                            <span>{{ doc.documents_type || doc.name || 'Document' }}</span>
                                        </div>
                                    </draggable>
                                    <div v-else-if="documents && documents.length"
                                        style="margin-left: 3px; margin-bottom: 15px">
                                        <div v-for="(doc, index) in documents" :key="index"
                                            style="margin-bottom: 10px;">
                                            <span
                                                style="margin-right: 10px; margin-bottom: 10px; margin-top: 10px; cursor: pointer;"
                                                @click="openDocument(doc.documents)">
                                                <i class="fas fa-file-pdf" style="margin-right: 5px;"></i>
                                                Pdf
                                            </span>
                                            <button @click="downloadDocument(doc.documents)"
                                                class="btn btn-primary btn-sm ml-2">
                                                Download
                                            </button>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <span>No document available</span>
                                    </div>
                                </b-form-group>
                            </div>

                            <div class="col-12">
                                <b-form-group label="Vehicle Automark Tattoos:" label-for="tattoos">
                                    <div v-if="tattoos && tattoos.length" class="d-flex flex-wrap">
                                        <div
                                            v-for="(tattoo, index) in tattoos"
                                            :key="tattoo.id || index"
                                            class="mr-3 mb-3 text-center"
                                            style="max-width: 180px;"
                                        >
                                            <img
                                                :src="'https://wossdb.wossautoid.com/' + tattoo.image"
                                                :alt="tattoo.title"
                                                class="img-thumbnail"
                                                style="width: 160px; height: 120px; object-fit: cover; cursor: pointer;"
                                                @click="openLightbox(tattoo.image)"
                                            />
                                            <div class="small font-weight-bold mt-2">{{ tattoo.title }}</div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <span>No tattoo locations available</span>
                                    </div>
                                </b-form-group>
                            </div>


                        </div>
                    </b-form>
                </div>
                <div v-if="codeActive" class="col-12 mt-24 hljs-container" :class="{ active: codeActiveClass }">
                    <pre v-highlightjs>
              <code class="hljs html">
                {{ codeText }}
              </code>
            </pre>
                </div>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import {
    BRow,
    BCol,
    BCard,
    BButton,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormSelect,
    BFormInput,
    BSpinner,
} from "bootstrap-vue";
// import axios from "axios";
import axios from "../../../axios";
import { BToast } from "bootstrap-vue";
import code from "@/view/components/data-entry/form/code";

export default {
    data() {
        return {
            show: true,
            codeText: code.introduction,
            codeActive: false,
            codeActiveClass: false,
            selectedOption: "",
            commission: "",
            selectedCarType: "",
            inputField1: "",
            inputField2: "",
            inputField3: "",
            showModal: false,
            isLoading: false,
            // Add Driver
            // company_name: "",
            model: "",
            color: "",
            category: "",
            license_plate: "",
            brand: "",
            types: "",
            engine_number: "",
            registration_number: "",
            vin: "",
            uic: "",
            year: "",
            status: "safe",
            image: [],
            userId: "",
            documents: [],
            vehicleId: "",
            imageReorderMode: false,
            imageList: [],
            savingImageOrder: false,
            docReorderMode: false,
            docList: [],
            savingDocOrder: false,
            features: "",
            description: "",
            lightboxVisible: false,
            selectedImage: '',
            successMessage: "",
            install_date: "",
            SystemNo: "",
            insurance_company_name: "",
            insurance_policy_number: "",
            insurance_expiration_date: "",
            tattoos: [],

        };
    },
    components: {
        BRow,
        BCol,
        BCard,
        BButton,
        BForm,
        BFormGroup,
        BFormCheckboxGroup,
        BFormCheckbox,
        BFormSelect,
        BFormInput,
        BToast,
        BSpinner,
        draggable,
    },

    created() {
        // Load the clients data when the component is created
        const userId = this.$route.params.id;
          this.type = localStorage.getItem("type");
        const endpoint = this.type === "manager" ? "vehicleShowManager" : "vehicleShow";
        axios
        axios.get(`${endpoint}/${userId}`)
            .then((response) => {
                const user = response.data.data;
                this.editedUser = user;
                // this.company_name = user.company_name ||'';
                this.model = user.model.title || '';
                this.category = user.category.title || '';
                this.color = user.color || '';
                this.license_plate = user.license_plate || '';
                this.brand = user.brand.name || '';
                this.types = user.types || '';
                this.engine_number = user.engine_number || '';
                this.image = user.image || '';
                this.registration_number = user.registration_number || '';
                this.vin = user.vin || '';
                this.uic = user.uic || '';
                this.year = user.year || '';
                this.status = user.status || '';
                this.features = user.features || '';
                this.description = user.description || '';
                this.documents = user.documents || '';
                this.install_date = user.install_date || '';
                this.SystemNo = user.SystemNo || '';
                this.insurance_company_name = user.insurance_company_name || '';
                this.insurance_policy_number = user.insurance_policy_number || '';
                this.insurance_expiration_date = user.insurance_expiration_date || '';
                this.tattoos = user.tattoos || [];
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);
            });
    },
    methods: {

        openLightbox(imgPath) {
            this.selectedImage = `https://wossdb.wossautoid.com/${imgPath}`;
            this.lightboxVisible = true;
        },
        closeLightbox() {
            this.lightboxVisible = false;
        },

        showMsgBoxOne() {
            debugger;
        },
        onSubmit(event) {
            event.preventDefault();
            alert(JSON.stringify(this.form));
            // debugger
        },

        onProfilePictureChange(event) {
            const files = event.target.files;
            if (files && files.length > 0) {
                this.image = Array.from(files).map(file => URL.createObjectURL(file));
            }
        },

        codeClick() {
            this.codeActive = !this.codeActive;
        },

        saveOwnCar() {
            this.showModal = false;
        },
        downloadDocument(docPath) {
            const link = document.createElement('a');
            link.href = `https://wossdb.wossautoid.com/${docPath}`;
            link.download = docPath.split('/').pop();
            link.click();
        },

        toggleImageReorder() {
            if (this.imageReorderMode) {
                this.imageReorderMode = false;
                this.imageList = [];
                return;
            }
            this.imageList = [...this.image];
            this.imageReorderMode = true;
        },
        async saveImageOrder() {
            this.savingImageOrder = true;
            try {
                await axios.post(`vehicleReorderImages/${this.editedUser.id}`, { images: this.imageList });
                this.image = [...this.imageList];
                this.imageReorderMode = false;
                this.imageList = [];
                this.$bvToast.toast("Image order saved successfully!", {
                    title: "Success", variant: "primary", solid: true,
                    toaster: "b-toaster-top-right", autoHideDelay: 3000,
                });
            } catch (error) {
                console.error("Error saving image order:", error);
                this.$bvToast.toast("Error saving image order!", {
                    title: "Error", variant: "danger", solid: true,
                    toaster: "b-toaster-top-right", autoHideDelay: 5000,
                });
            } finally {
                this.savingImageOrder = false;
            }
        },
        toggleDocReorder() {
            if (this.docReorderMode) {
                this.docReorderMode = false;
                this.docList = [];
                return;
            }
            this.docList = [...this.documents];
            this.docReorderMode = true;
        },
        async saveDocOrder() {
            this.savingDocOrder = true;
            try {
                const ids = this.docList.map(doc => doc.id);
                await axios.post("documentsReorder", { ids });
                this.documents = [...this.docList];
                this.docReorderMode = false;
                this.docList = [];
                this.$bvToast.toast("Document order saved successfully!", {
                    title: "Success", variant: "primary", solid: true,
                    toaster: "b-toaster-top-right", autoHideDelay: 3000,
                });
            } catch (error) {
                console.error("Error saving document order:", error);
                this.$bvToast.toast("Error saving document order!", {
                    title: "Error", variant: "danger", solid: true,
                    toaster: "b-toaster-top-right", autoHideDelay: 5000,
                });
            } finally {
                this.savingDocOrder = false;
            }
        },

    },
};
</script>

<style scoped>
.reorder-image-item {
    position: relative;
    padding: 4px;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    background: #fff;
}
.reorder-row {
    background: #fff;
    transition: background 0.2s;
}
.reorder-row:hover {
    background: #f0f2f5;
}
.drag-handle:hover {
    color: #2f855a;
}
.lightbox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.lightbox-content {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    max-width: 90%;
    max-height: 90%;
    overflow: auto;
}

.lightbox-image {
    max-width: 100%;
    max-height: 80vh;
}
</style>
